import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Toaster } from "sonner";
import ScrollToTop from "@/components/ScrollToTop";
import BouncingLogoLoader, { usePreloaderVariant } from "@/components/BouncingLogoLoader";
import PocPage from "@/pages/PocPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/admin/PasswordResetPages";
import LandingAndPayments from "@/pages/admin/LandingAndPayments";
import Dashboard from "@/pages/admin/Dashboard";
import AdminClassifieds from "@/pages/admin/AdminClassifieds";
import AdminAuthors from "@/pages/admin/AdminAuthors";
import AdminTips from "@/pages/admin/AdminTips";
import AdminDatabase from "@/pages/admin/AdminDatabase";
import AdminPortalManage from "@/pages/admin/AdminPortalManage";
import AdminBreakingNews from "@/pages/admin/AdminBreakingNews";
import AdminI18nCoverage from "@/pages/admin/AdminI18nCoverage";
import ArticlesList from "@/pages/admin/ArticlesList";
import ArticleForm from "@/pages/admin/ArticleForm";
import ArticlePreview from "@/pages/admin/ArticlePreview";import Categories from "@/pages/admin/Categories";
import Tags from "@/pages/admin/Tags";
import Media from "@/pages/admin/Media";
import NewsSubmissions from "@/pages/admin/NewsSubmissions";
import AdInquiries from "@/pages/admin/AdInquiries";
import AdminPlacementAds from "@/pages/admin/AdminPlacementAds";
import Newsletter from "@/pages/admin/Newsletter";
import TranslateJobs from "@/pages/admin/TranslateJobs";
import TranslationQueue from "@/pages/admin/TranslationQueue";
import Partners from "@/pages/admin/Partners";
import Observability from "@/pages/admin/Observability";
import AnalyticsDashboard from "@/pages/admin/AnalyticsDashboard";
import SiteSettings from "@/pages/admin/SiteSettings";
import AdminFeedsV3 from "@/pages/admin/AdminFeedsV3";
import AdminPolls from "@/pages/admin/AdminPolls";
import AdminPush from "@/pages/admin/AdminPush";
import ArticleVersions from "@/pages/admin/ArticleVersions";
import StaticPagesList from "@/pages/admin/StaticPagesList";
import StaticPageEdit from "@/pages/admin/StaticPageEdit";
import ContactMessages from "@/pages/admin/ContactMessages";
import HomepageSettings from "@/pages/admin/HomepageSettings";
import BrandingSettings from "@/pages/admin/BrandingSettings";
import WordPressImport from "@/pages/admin/WordPressImport";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminQuizzes from "@/pages/admin/AdminQuizzes";
import AdminHeatmap from "@/pages/admin/AdminHeatmap";
import AdminAISettings from "@/pages/admin/AdminAISettings";
import AdminLLMUsage from "@/pages/admin/AdminLLMUsage";
import AdminAIPrompts from "@/pages/admin/AdminAIPrompts";
import AdminContentHealth from "@/pages/admin/AdminContentHealth";
import AdminWeeklyReports from "@/pages/admin/AdminWeeklyReports";
import AdminSystemHealth from "@/pages/admin/AdminSystemHealth";
import AdminCryptoTips from "@/pages/admin/AdminCryptoTips";
import AdminComments from "@/pages/admin/AdminComments";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminAuditLog from "@/pages/admin/AdminAuditLog";
import AdminDuplicates from "@/pages/admin/AdminDuplicates";
import AdminBugReports from "@/pages/admin/AdminBugReports";
import AdminEmailLog from "@/pages/admin/AdminEmailLog";
import AdminMenuManager from "@/pages/admin/AdminMenuManager";
import AdminSidebarEditor from "@/pages/admin/AdminSidebarEditor";
import AdminSubscriptions from "@/pages/admin/AdminSubscriptions";
import AdminPromoCodes from "@/pages/admin/AdminPromoCodes";
import AdminVouchers from "@/pages/admin/AdminVouchers";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminInvoices from "@/pages/admin/AdminInvoices";
import AdminPricing from "@/pages/admin/AdminPricing";
import AdminMicropayments from "@/pages/admin/AdminMicropayments";
import AdminMonetization from "@/pages/admin/AdminMonetization";
import AdminWorkflow from "@/pages/admin/AdminWorkflow";
import AdminContentSchedule from "@/pages/admin/AdminContentSchedule";
import AdminContentCalendar from "@/pages/admin/AdminContentCalendar";
import AdminSanitize from "@/pages/admin/AdminSanitize";
import AdminAdvancedAnalytics from "@/pages/admin/AdminAdvancedAnalytics";
import AdminABTesting from "@/pages/admin/AdminABTesting";
import AdminVisitorMap from "@/pages/admin/AdminVisitorMap";
import AdminAIRecommendations from "@/pages/admin/AdminAIRecommendations";
import AdminPerformanceForecast from "@/pages/admin/AdminPerformanceForecast";
import AdminCompetitorTracking from "@/pages/admin/AdminCompetitorTracking";
import AdminChurnPrediction from "@/pages/admin/AdminChurnPrediction";
import AdminSEODashboard from "@/pages/admin/AdminSEODashboard";
import AdminAMPDiscover from "@/pages/admin/AdminAMPDiscover";
import AdminSponsoredOrders from "@/pages/admin/AdminSponsoredOrders";
import AdminErrorLog from "@/pages/admin/AdminErrorLog";
import AdminSyndication from "@/pages/admin/AdminSyndication";
import AdminNewsletterDigest from "@/pages/admin/AdminNewsletterDigest";
import AdminEmailCampaigns from "@/pages/admin/AdminEmailCampaigns";
import AdminSocial from "@/pages/admin/AdminSocial";
import AdminAdsense from "@/pages/admin/AdminAdsense";
import AdminAdReports from "@/pages/admin/AdminAdReports";
import AdminSecurity from "@/pages/admin/AdminSecurity";
import AdminComplaints from "@/pages/admin/AdminComplaints";
import AdminCountyMap from "@/pages/admin/AdminCountyMap";
import AdminPhotoCheck from "@/pages/admin/AdminPhotoCheck";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminSponsored from "@/pages/admin/AdminSponsored";
import AdminAdDiscounts from "@/pages/admin/AdminAdDiscounts";
import AdminSponsoredSettings from "@/pages/admin/AdminSponsoredSettings";
import AdminListingPromotion from "@/pages/admin/AdminListingPromotion";
import AdminTranslationProvider from "@/pages/admin/AdminTranslationProvider";
import AdminSeries from "@/pages/admin/AdminSeries";
import AdminMarketingDiscounts from "@/pages/admin/AdminMarketingDiscounts";
import AdminInbox from "@/pages/admin/AdminInbox";
import AdminBrokenImages from "@/pages/admin/AdminBrokenImages";
import MaintenanceGate from "@/components/MaintenanceGate";
import ComingSoonPage from "@/pages/admin/ComingSoonPage";
import GenericModulePage from "@/pages/admin/GenericModulePage";
import { MODULE_CONFIGS } from "@/pages/admin/modulesConfig";
import PublicLayout from "@/pages/public/PublicLayout";
import HomePage from "@/pages/public/HomePage";
import ArticlePage from "@/pages/public/ArticlePage";
import CategoryPage from "@/pages/public/CategoryPage";
import SearchPage from "@/pages/public/SearchPage";
import WeatherPage from "@/pages/public/WeatherPage";
import MapPage from "@/pages/public/MapPage";
import AuthorPage from "@/pages/public/AuthorPage";
import SavedPage from "@/pages/public/SavedPage";
import SubscribePage from "@/pages/public/SubscribePage";
import SubmitNewsPage from "@/pages/public/SubmitNewsPage";
import JobSubmitPage from "@/pages/public/JobSubmitPage";
import ClassifiedSubmitPage from "@/pages/public/ClassifiedSubmitPage";
import ClassifiedDetailPage from "@/pages/public/ClassifiedDetailPage";
import MyListingsPage from "@/pages/public/MyListingsPage";
import AdvertisingPage from "@/pages/public/AdvertisingPage";
import SponsoredPurchasePage from "@/pages/public/SponsoredPurchasePage";
import DiscountLinkLanding from "@/pages/public/DiscountLinkLanding";
import JobsPage from "@/pages/public/JobsPage";
import JobDetailPage from "@/pages/public/JobDetailPage";
import ClassifiedsPage from "@/pages/public/ClassifiedsPage";
import QuizzesPage from "@/pages/public/QuizzesPage";
import QuizPlayPage from "@/pages/public/QuizPlayPage";
import CryptoTipsPage from "@/pages/public/CryptoTipsPage";
import StaticPage from "@/pages/public/StaticPage";
import ContactPage from "@/pages/public/ContactPage";
import ConsentPage from "@/pages/public/ConsentPage";
import PrijavaPage from "@/pages/public/PrijavaPage";
import CityPortalPage from "@/pages/public/CityPortalPage";
import AdminReview from "@/pages/admin/AdminReview";
import AdminPremiumPromo from "@/pages/admin/AdminPremiumPromo";
import AdminImprint from "@/pages/admin/AdminImprint";
import AdminFeedsAnalyzer from "@/pages/admin/AdminFeedsAnalyzer";
import NotFound from "@/pages/public/NotFound";

function CallbackHandler() {
  const { isLoading, isAuthenticated } = useAuth0();
  const variant = usePreloaderVariant();
  if (isLoading) return <BouncingLogoLoader variant={variant} fullscreen label="Prijava u tijeku…" />;
  return <Navigate to={isAuthenticated ? "/admin" : "/"} replace />;
}

// Factory: build a functional admin page for every module key defined in
// modulesConfig. This replaces the former ComingSoonPage placeholders —
// editors get real CRUD instead of an "under development" notice.
function ModuleRoute({ moduleKey }) {
  const cfg = MODULE_CONFIGS[moduleKey] || MODULE_CONFIGS.generic;
  return <GenericModulePage moduleKey={moduleKey} {...cfg} />;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" theme="dark" />
      <BrowserRouter>
        <ScrollToTop />
        <MaintenanceGate>
        <Routes>
          {/* Public routes — all inside PublicLayout for header+footer */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/kategorija/:slug" element={<CategoryPage />} />
            <Route path="/clanak/:slug" element={<ArticlePage />} />
            <Route path="/pretraga" element={<SearchPage />} />
            <Route path="/pretplata" element={<SubscribePage />} />
            <Route path="/pretplata/uspjeh" element={<SubscribePage />} />
            <Route path="/pretplata/otkazano" element={<SubscribePage />} />
            <Route path="/predaj-vijest" element={<SubmitNewsPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/oglasavanje" element={<AdvertisingPage />} />
            <Route path="/sponzorirani-clanak" element={<SponsoredPurchasePage />} />
            <Route path="/popust/:token" element={<DiscountLinkLanding />} />
            <Route path="/posao" element={<JobsPage />} />
            <Route path="/posao/:id" element={<JobDetailPage />} />
            <Route path="/posao/predaj" element={<JobSubmitPage />} />
            <Route path="/oglasnik" element={<ClassifiedsPage />} />
            <Route path="/oglasnik/:id" element={<ClassifiedDetailPage />} />
            <Route path="/oglasnik/predaj" element={<ClassifiedSubmitPage />} />
            <Route path="/moji-oglasi" element={<MyListingsPage />} />
            <Route path="/kvizovi" element={<QuizzesPage />} />
            <Route path="/kviz/:slug" element={<QuizPlayPage />} />
            <Route path="/kripto" element={<CryptoTipsPage />} />
            {/* Static content pages */}
            <Route path="/impressum" element={<StaticPage slug="impressum" />} />
            <Route path="/o-nama" element={<StaticPage slug="o-nama" />} />
            <Route path="/politika-privatnosti" element={<ConsentPage slug="politika-privatnosti" />} />
            <Route path="/postavke-kolacica" element={<StaticPage slug="postavke-kolacica" />} />
            <Route path="/pravila-komentiranja" element={<ConsentPage slug="pravila-komentiranja" />} />
            <Route path="/pravila-prenosenja-sadrzaja" element={<StaticPage slug="pravila-prenosenja-sadrzaja" />} />
            <Route path="/vrijeme" element={<WeatherPage />} />
            <Route path="/mapa" element={<MapPage />} />
            <Route path="/autori/:slug" element={<AuthorPage />} />
            <Route path="/spremljeno" element={<SavedPage />} />
            <Route path="/grad/:slug" element={<CityPortalPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/prijava" element={<PrijavaPage />} />
          <Route path="/callback" element={<CallbackHandler />} />
          <Route path="/poc" element={<PocPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="articles" element={<ArticlesList />} />
            <Route path="articles/new" element={<ArticleForm />} />
            <Route path="articles/:id/edit" element={<ArticleForm />} />
            <Route path="articles/:id/preview" element={<ArticlePreview />} />
            <Route path="articles/:id/versions" element={<ArticleVersions />} />
            <Route path="polls" element={<AdminPolls />} />
            <Route path="push" element={<AdminPush />} />
            <Route path="categories" element={<Categories />} />
            <Route path="tags" element={<Tags />} />
            <Route path="media" element={<Media />} />
            <Route path="news-submissions" element={<NewsSubmissions />} />
            <Route path="ad-inquiries" element={<AdInquiries />} />
            <Route path="newsletter" element={<Newsletter />} />
            <Route path="translate-jobs" element={<TranslateJobs />} />
            <Route path="translations/missing" element={<TranslationQueue />} />
            <Route path="partners" element={<Partners />} />
            <Route path="analytics" element={<AnalyticsDashboard />} />
            <Route path="settings" element={<SiteSettings />} />
            <Route path="rss" element={<AdminFeedsV3 />} />
            <Route path="observability" element={<Observability />} />
            <Route path="static-pages" element={<StaticPagesList />} />
            <Route path="static-pages/:slug/edit" element={<StaticPageEdit />} />
            <Route path="contact-messages" element={<ContactMessages />} />
            <Route path="homepage-settings" element={<HomepageSettings />} />
            <Route path="branding" element={<BrandingSettings />} />
            <Route path="landing" element={<LandingAndPayments />} />
            <Route path="import/wordpress" element={<WordPressImport />} />
            <Route path="wp-import" element={<WordPressImport />} />
            <Route path="jobs" element={<AdminJobs />} />
            <Route path="quizzes" element={<AdminQuizzes />} />
            <Route path="heatmap" element={<AdminHeatmap />} />
            <Route path="feeds" element={<AdminFeedsV3 />} />
            <Route path="feeds-v3" element={<AdminFeedsV3 />} />
            <Route path="feeds-v2" element={<AdminFeedsV3 />} />
            <Route path="ai-content" element={<AdminAISettings />} />
            <Route path="ai-settings" element={<AdminAISettings />} />
            <Route path="llm-usage" element={<AdminLLMUsage />} />
            <Route path="ai-prompts" element={<AdminAIPrompts />} />
            <Route path="content-health" element={<AdminContentHealth />} />
            <Route path="weekly-reports" element={<AdminWeeklyReports />} />
            <Route path="system-health" element={<AdminSystemHealth />} />
            <Route path="crypto-tips" element={<AdminCryptoTips />} />
            <Route path="comments" element={<AdminComments />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="audit-log" element={<AdminAuditLog />} />
            <Route path="duplicates" element={<AdminDuplicates />} />
            <Route path="bug-reports" element={<AdminBugReports />} />
            <Route path="email-log" element={<AdminEmailLog />} />
            <Route path="menu-manager" element={<AdminMenuManager />} />
            <Route path="sidebar-editor" element={<AdminSidebarEditor />} />
            <Route path="classifieds" element={<AdminClassifieds />} />
            <Route path="authors" element={<AdminAuthors />} />
            <Route path="tips" element={<AdminTips />} />
            <Route path="i18n-coverage" element={<AdminI18nCoverage />} />
            {/* P1 modules */}
            <Route path="subscriptions" element={<AdminSubscriptions />} />
            <Route path="promo-codes" element={<AdminPromoCodes />} />
            <Route path="marketing-discounts" element={<AdminMarketingDiscounts />} />
            <Route path="inbox" element={<AdminInbox />} />
            <Route path="broken-images" element={<AdminBrokenImages />} />
            <Route path="vouchers" element={<AdminVouchers />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="invoices" element={<AdminInvoices />} />
            <Route path="pricing" element={<AdminPricing />} />
            <Route path="micropayments" element={<AdminMicropayments />} />
            <Route path="monetization" element={<AdminMonetization />} />
            <Route path="workflow" element={<AdminWorkflow />} />
            <Route path="content-schedule" element={<AdminContentSchedule />} />
            <Route path="content-calendar" element={<AdminContentCalendar />} />
            <Route path="sanitize" element={<AdminSanitize />} />
            <Route path="advanced-analytics" element={<AdminAdvancedAnalytics />} />
            <Route path="ab-testing" element={<AdminABTesting />} />
            <Route path="visitor-map" element={<AdminVisitorMap />} />
            <Route path="ai-recommendations" element={<AdminAIRecommendations />} />
            <Route path="performance-forecast" element={<AdminPerformanceForecast />} />
            <Route path="competitor-tracking" element={<AdminCompetitorTracking />} />
            <Route path="churn-prediction" element={<AdminChurnPrediction />} />
            <Route path="seo-dashboard" element={<AdminSEODashboard />} />
            <Route path="amp-discover" element={<AdminAMPDiscover />} />
            <Route path="syndication" element={<AdminSyndication />} />
            <Route path="newsletter-digest" element={<AdminNewsletterDigest />} />
            <Route path="email-campaigns" element={<AdminEmailCampaigns />} />
            <Route path="social" element={<AdminSocial />} />
            <Route path="adsense" element={<AdminAdsense />} />
            <Route path="ad-reports" element={<AdminAdReports />} />
            <Route path="security" element={<AdminSecurity />} />
            <Route path="complaints" element={<AdminComplaints />} />
            <Route path="county-map" element={<AdminCountyMap />} />
            <Route path="photo-check" element={<AdminPhotoCheck />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="sponsored" element={<AdminSponsored />} />
            <Route path="sponsored-orders" element={<AdminSponsoredOrders />} />
            <Route path="error-log" element={<AdminErrorLog />} />
            <Route path="sponsored-settings" element={<AdminSponsoredSettings />} />
            <Route path="listing-promotion" element={<AdminListingPromotion />} />
            <Route path="translation-provider" element={<AdminTranslationProvider />} />
            <Route path="ad-discounts" element={<AdminAdDiscounts />} />
            <Route path="series" element={<AdminSeries />} />
            <Route path="review" element={<AdminReview />} />
            <Route path="premium-promo" element={<AdminPremiumPromo />} />
            <Route path="imprint-widget" element={<AdminImprint />} />
            <Route path="rss-analyzer" element={<AdminFeedsAnalyzer />} />
            {/* Former "Coming soon" routes — now real CRUD modules via MODULE_CONFIGS */}
            <Route path="analytics-live" element={<ModuleRoute moduleKey="analytics-live" />} />
            <Route path="breaking-news-module" element={<ModuleRoute moduleKey="breaking-news" />} />
            <Route path="breaking-expiry" element={<ModuleRoute moduleKey="breaking-expiry" />} />
            <Route path="streams" element={<ModuleRoute moduleKey="streams" />} />
            <Route path="imprint" element={<AdminImprint />} />
            <Route path="bulk-ops" element={<ModuleRoute moduleKey="bulk-ops" />} />
            <Route path="times-posao" element={<ModuleRoute moduleKey="times-posao" />} />
            <Route path="sponsored-market" element={<ModuleRoute moduleKey="sponsored-market" />} />
            <Route path="ads" element={<AdminPlacementAds />} />
            <Route path="free-ads" element={<AdminPlacementAds />} />
            <Route path="purchased-ads" element={<AdminPlacementAds />} />
            <Route path="advertise-analytics" element={<ModuleRoute moduleKey="advertise-analytics" />} />
            <Route path="social-schedule" element={<ModuleRoute moduleKey="social-schedule" />} />
            <Route path="chat-sessions" element={<ModuleRoute moduleKey="chat-sessions" />} />
            <Route path="documentation" element={<ModuleRoute moduleKey="documentation" />} />
            <Route path="content-reports" element={<ModuleRoute moduleKey="content-reports" />} />
            <Route path="widgets" element={<ModuleRoute moduleKey="widgets" />} />
            <Route path="times-brands" element={<ModuleRoute moduleKey="times-brands" />} />
            <Route path="crypto-widget" element={<ModuleRoute moduleKey="crypto-widget" />} />
            <Route path="portal-manage" element={<AdminPortalManage />} />
            <Route path="database" element={<AdminDatabase />} />
            <Route path="breaking-news" element={<AdminBreakingNews />} />
            <Route path="doctor-revenue" element={<ModuleRoute moduleKey="doctor-revenue" />} />
            <Route path="version-history" element={<ModuleRoute moduleKey="version-history" />} />
            <Route path="citizen-content" element={<ModuleRoute moduleKey="citizen-content" />} />
            <Route path="database-module" element={<ModuleRoute moduleKey="database" />} />
            <Route path="offer-generator" element={<ModuleRoute moduleKey="offer-generator" />} />
            <Route path="footer-partners" element={<ModuleRoute moduleKey="footer-partners" />} />
            <Route path="polls-analytics" element={<ModuleRoute moduleKey="polls-analytics" />} />
            {/* Roadmap safety net — any remaining unmatched admin path still renders ComingSoon */}
            <Route path="coming-soon" element={<ComingSoonPage />} />
            <Route path="*" element={<ComingSoonPage />} />
          </Route>
        </Routes>
        </MaintenanceGate>
      </BrowserRouter>
    </div>
  );
}

export default App;
